/* @flow */

import * as React from 'react';
import type {FieldProps} from 'redux-form';
import {useQuery} from '@apollo/react-hooks';

import type {GetStagesets as GetStagesetsQuery} from 'nutshell-graphql-types';
import {ReduxFormSelectPickerGeneric} from 'shells/redux-form-fields';

import GET_STAGESETS from '../../../lead/queries/get-stagesets.graphql';
import {AUTO_RESOLVE_ID} from './helpers';

const AUTO_DISTRIBUTE_OPTION = {
    value: AUTO_RESOLVE_ID, // need a unique id which we set to undefined before sending it to the backend
    label: 'Auto distribute',
};

// Redux-based pipeline select that renders as a dropdown
// (does not turn into a "card" when it has a value)
export function PipelineSelectSingle(props: FieldProps) {
    const {data} = useQuery<GetStagesetsQuery, {}>(GET_STAGESETS, {
        notifyOnNetworkStatusChange: true,
    });

    let options = data
        ? data.stagesets.map((stageset) => {
              return {
                  label: stageset.name,
                  value: stageset.id,
              };
          })
        : [];

    options = [AUTO_DISTRIBUTE_OPTION, ...options];

    React.useEffect(() => {
        if (!props.input.value) {
            props.input.onChange(AUTO_DISTRIBUTE_OPTION.value);
        }
    }, [props.input]);

    const selectedValue = options.find((field) => field.value === props.input.value);

    return (
        // $FlowIgnore this is because of the way we're passing the props through
        <ReduxFormSelectPickerGeneric
            {...props}
            onRemove={() => props.input.onChange(null)}
            options={options}
            placeholder='Select a pipeline'
            value={selectedValue}
        />
    );
}
